export const createFieldDisabledState = (
  array: string[],
  ignoreFields: string[]
) => {
  const state: any = {}
  array.forEach((item, index) => {
    if (index === 0 || ignoreFields.includes(item))
      state[item] = { position: index, disabled: false }
    else state[item] = { position: index, disabled: true }
  })

  return state
}
